// TenantContext.tsx
import { createContext, useContext } from 'react';
import { TenantConfig } from '../util/bootTheme';

export const TenantContext = createContext<TenantConfig | undefined>(undefined);
export const useTenant = () => useContext(TenantContext);
